import { reducer as form } from 'redux-form';
import storage from 'redux-persist/es/storage';
import { persistCombineReducers } from 'redux-persist';
import auth from './auth';
import journal from './journal';
import structure from './structure';
import faculty from './faculty';
import cathedra from './cathedra';
import certification from './certification';
import group from './group';
import schedule from './schedule';
import document from './document';
import ktp from './ktp';
import umk from './umk';
import discipline from './discipline';
import lk from './lk';
import portfolio from './portfolio';
import layout from './layout';
import credits from './credits';
import performance from './performance';
import metoRoom from './metoRoom';
import management from './management';
import program from './program';
import currentPerformance from './currentPerformance';
import booksRequest from './booksRequest';
import newBook from './newBook';
import personnel from './personnel';
import lessonHomeworkFiles from './lessonHomeworkFiles';
import studentHomeworkFiles from './studentHomeworkFiles';
import lessonResultFiles from './lessonResultFiles';
import studentResultFiles from './studentResultFiles';
import booksRequestFilter from './booksRequestFilter';
import curriculumData from './curriculumData';
import courseBooks from './disciplinePrograms';
import educationWorkPrograms from './educationWorkPrograms';
import booksInfo from './booksInfo';
import courseBooksReducer from './CourseBooks/actions';
import report from './report';
import radar from './radar';
import scientificWork from './scientificWorkReducer';
import lessonPlan from './lessonPlanReducer';
import complexTopicsDisciplines from './complexTopicsDiscipline';
import individualWorkPlan from './individualWorkPlanReducer';
import testing from './testing';
import grants from './grants';
import encryptionKeys from './encryptionKeys';
import methodPlan from './methodPlan';
import scheduleMTO from './scheduleMTO';
import announcement from './announcement';
import criterias from './criterias';
import reviews from './reviews';
import dashboard from './dashboard';
import carousel from './carousel';
import infoKiosk from './infoKiosk';
import infoTerminal from './infoTerminal';
import tvPanel from './tvPanel';
import programModules from './programModules';
import eventsCalendar from './eventsCalendar';
import thematicPlanning from './thematicPlanning';
import teacherSchedule from './teacherSchedule';


const storageConfig = { whitelist: ['auth', 'lk'], key: 'storage', storage };

export default persistCombineReducers(storageConfig, {
  announcement,
  auth,
  booksInfo,
  booksRequest,
  booksRequestFilter,
  carousel,
  cathedra,
  certification,
  complexTopicsDisciplines,
  courseBooks,
  courseBooksReducer,
  credits,
  criterias,
  currentPerformance,
  curriculumData,
  dashboard,
  discipline,
  document,
  educationWorkPrograms,
  encryptionKeys,
  eventsCalendar,
  faculty,
  form,
  grants,
  group,
  individualWorkPlan,
  infoKiosk,
  infoTerminal,
  journal,
  ktp,
  layout,
  lessonHomeworkFiles,
  lessonPlan,
  lessonResultFiles,
  lk,
  management,
  methodPlan,
  metoRoom,
  newBook,
  performance,
  personnel,
  portfolio,
  program,
  programModules,
  radar,
  report,
  reviews,
  schedule,
  scheduleMTO,
  scientificWork,
  structure,
  studentHomeworkFiles,
  studentResultFiles,
  teacherSchedule,
  testing,
  thematicPlanning,
  tvPanel,
  umk,
});
